import { gql } from "@apollo/client";

export const GET_NEXT_NUMBERING_OF_SECRETARY = gql`
  query Query {
    getNextNumberingOfSecretary
  }
`;

export const CREATE_SECRETARY_IN_MANDATE = gql`
  mutation CreateSecretaryInMandate($input: SecretaryInMandateInput!) {
    createSecretaryInMandate(input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const UPDATE_SECRETARY_IN_MANDATE = gql`
  mutation UpdateSecretaryInMandate(
    $id: ID!
    $input: SecretaryInMandateInput!
  ) {
    updateSecretaryInMandate(_id: $id, input: $input) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const DELETE_SECRETARY_IN_MANDATE = gql`
  mutation DeleteSecretaryInMandate($id: ID!) {
    deleteSecretaryInMandate(_id: $id) {
      isSuccess
      message {
        messageKh
        messageEn
      }
    }
  }
`;

export const GET_SECRETARY_IN_MANDATE_PAGINATION = gql`
  query GetSecretaryInMandatePagination(
    $page: Int
    $limit: Int
    $keyword: String
    $pagination: Boolean
  ) {
    getSecretaryInMandatePagination(
      page: $page
      limit: $limit
      keyword: $keyword
      pagination: $pagination
    ) {
      data {
        _id
        numbering
        userId {
          phoneNumber
          lastNameKh
          gender
          firstNameKh
          email
          dateOfBirth
          _id
        }
        roleInSecretariat
      }
      paginator {
        slNo
        prev
        next
        perPage
        totalPosts
        totalPages
        currentPage
        hasPrevPage
        hasNextPage
        totalDocs
      }
    }
  }
`;
